<template>
	<section
		class="relative flex w-full flex-col md:flex-row items-center justify-between px-4 md:px-10 pt-21 pb-30 bg-white mx-auto lg:grid lg:grid-cols-2 lg:px-17 max-w-screen-2xl"
	>
		<div
			class="flex-1 flex flex-col items-start justify-center z-10 antialiased"
		>
			<h2 class="text-teal-700 text-2xl font-semibold mb-4.5 tracking-wide">
				Diversey GPS
			</h2>
			<h1
				class="text-4xl md:text-5xl lg:text-[53px] font-bold text-slate-950 mb-6 leading-12 md:leading-[65px] max-w-xl"
			>
				{{
					getTranslations(
						"Innovative Solution for the Food & Beverage Industry",
					)
				}}
			</h1>
			<p
				class="text-slate-950/70 text-base leading-[26px] mb-14 md:mb-6 max-w-160"
			>
				{{
					getTranslations(
						"From beverage production to dairy, food processing, agriculture, and life sciences – we provide innovative solutions to optimize efficiency, enhance safety, and ensure compliance. Discover tailored products and services designed to meet your industry's unique challenges.",
					)
				}}
			</p>
			<button
				class="group flex items-center gap-2 transition-all duration-200 ease-out hover:gap-3 cursor-pointer"
					@click="scrollToMenu"
			>
				<span
					class="bg-blue-400 text-white rounded-full p-2 transition-all duration-200 ease-out group-hover:bg-blue-500"
				>
					<svg
						width="24"
						height="24"
						fill="none"
						viewBox="0 0 24 24"
						class="transition-transform duration-200 group-hover:translate-x-0.5"
					>
						<path
							d="M5 12h14M13 5l7 7-7 7"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</span>
				<span
					class="ml-2 font-bold text-slate-950 text-base cursor-pointer transition-colors duration-200 group-hover:text-blue-500 capitalize"
					@click="scrollToMenu"
				>
					{{ getTranslations('select an industry to get started') }}
				</span>
			</button>
		</div>

		<div class="flex-1 md:flex items-center justify-end w-full relative hidden">
			<img
				src="/images/hero/hero.webp"
				alt="Hero Image"
				class="w-[75%] h-full object-cover"
			/>
			<div
				class="absolute left-[30%] bottom-10 transform -translate-x-1/2 bg-white rounded-2xl hidden lg:flex items-center gap-3 pr-12 pl-3 overflow-hidden h-29 shadow-xl"
			>
				<img
					src="/images/icons/gps.svg"
					alt="Diversey GPS"
					width="120"
					height="120"
				/>
				<span
					class="font-bold text-xl text-slate-950 tracking-tight w-20 leading-6 -ml-6"
					>Diversey GPS</span
				>
			</div>
		</div>
	</section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "HomeHero",
	components: {},
	computed: {
		...mapGetters("staticContent", ["getTranslations"]),
	},
	methods: {
		scrollToMenu() {
			document.getElementById("home-menu").scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		},
	},
};
</script>
